
export default {
  data() {
    return {
      val: '',
      items: [
        {title: 'New York', value: 'NY'},
        {title: 'Rome', value: 'RM'},
        {title: 'London', value: 'LDN'},
        {title: 'Istanbul', value: 'IST'},
        {title: 'Paris', value: 'PRS'}
      ]
    }
  },
  methods: {
    onSendError() {
      throw new Error('Intended error to test Sentry')
    }
  }
}
